import React from "react";
import styled from 'styled-components';
import Button from '../../../atoms/button';
import I10n from '../../i10n';
import Checkbox from '../../../atoms/checkbox';
import { buildMySchneiderUrl } from "../../../utils/url-builder";
import { PRIMARY_COLOR } from "../../../color-constants";

const Container = styled.div`
  align-self: center;
  display: flex;
  flex-direction: column;
  max-width: 500px;
  padding: 15px;
  background-color: white;
  border: 1px solid #e7e6e6;
  box-shadow: 0 1px 3px 0 rgba(0,0,0,0.15);
  overflow: hidden;
  align-items: center;
  justify-content: center;
  margin: 16px;
`;

const TextBox = styled.div`
  justify-content: center;
  text-align: center;
  color: #626469;
`;

const Title = styled(TextBox)`
  font-size: 24px;
  letter-spacing: 0.19px;
  line-height: 28px;
  margin-bottom: 15px;
  font-weight: 700;
`;

const Text = styled(TextBox)`
  font-size: 16px;
  letter-spacing: 0.13px;
  line-height: 18px;
  margin-bottom: 15px;
`;

const ContinueAsGuest = styled.div`
  color: ${PRIMARY_COLOR};
  color: var(--se-secondary, ${PRIMARY_COLOR});
  cursor: pointer;
  margin: 15px 0px;
`;


// UNUSED
class ModalMySchneiderLogin extends React.PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      doNotShowAgain: false
    }
  }

  render = () => {
    return (
      <Container>
        <Title>{I10n.get('screen.start_configuration_screen.my_schneider_login.modal_title')}</Title>
        <Text>{I10n.get('screen.start_configuration_screen.my_schneider_login.modal_body')}</Text>
        <Button color="secondary" onClick={() => {
          document.location.href = buildMySchneiderUrl();
        }}>
          {I10n.get('app.action.login_register')}
        </Button>
        <ContinueAsGuest onClick={() => {
          if (this.state.doNotShowAgain) {
            try {
              localStorage.setItem('do-not-show-login', Date.now());
            } catch (error) {
            }
          }
          this.props.onContinueAsGuest();
        }}>{I10n.get('app.action.continue_guest')}
        </ContinueAsGuest>
        <Checkbox onChange={(event) => { event.preventDefault(); this.setState({ doNotShowAgain: !this.state.doNotShowAgain }) }} checked={this.state.doNotShowAgain} label={I10n.get('app.action.do_not_show_message_again')}></Checkbox>
      </Container >
    );
  }
}

export default ModalMySchneiderLogin;
